import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-questionary-exitintent',
  templateUrl: './questionary-exitintent.component.html',
  styleUrls: ['./questionary-exitintent.component.css']
})
export class QuestionaryExitintentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
